import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect } from './NotificationMenuContainer';
import { changeFavicon } from '../../../../utils/faviconUtils';
import styles from './notification_menu.module.scss';

type Props = {
  isNew: boolean;
};

export class RawNotificationMenu extends React.Component<Props> {
  render() {
    const { isNew } = this.props;
    changeFavicon(isNew);
    return (
      <span>
        <FormattedMessage id="navigation/notification/components/NotificationMenu.tsx/1" />
        {isNew && (
          <span
            data-test-id="new-notification-menu"
            className={styles.container}
          />
        )}
      </span>
    );
  }
}

export const NotificationMenu = Connect(RawNotificationMenu);
